<template>
  <div>
    <StatusButton v-if="readonly" :value="value" readonly />
    <DropdownComponent v-else close-on-click class="task-status">
      <template #default>
        <FontAwesomeIcon v-if="loading" :icon="['fal', 'spinner-third']" spin class="mr-1" />
        <StatusButton :value="value" />
      </template>
      <template #dropdown>
        <template v-if="value === 'request'">
          <ButtonComponent :label="$t('rejectRequest')" :icon="['fal', 'times']" @click="$emit('input', 'reject')" />
          <ButtonComponent :label="$t('confirmRequest')" :icon="['fal', 'check']" @click="$emit('input', 'undone')" />
        </template>
        <ButtonComponent
          v-if="value === 'undone'"
          :label="$t('completeTask')"
          :icon="['fal', 'check']"
          @click="$emit('input', 'done')"
        />
        <ButtonComponent
          v-if="value === 'done'"
          :label="$t('setTaskToUndone')"
          :icon="['fal', 'stop']"
          @click="$emit('input', 'undone')"
        />
        <ButtonComponent
          v-if="value === 'rejected'"
          :label="$t('confirmRequest')"
          :icon="['fal', 'check']"
          @click="$emit('input', 'undone')"
        />
      </template>
    </DropdownComponent>
  </div>
</template>

<script>
import { DropdownComponent } from 'vue-elder-dropdown'
import { ButtonComponent } from 'vue-elder-button'
import StatusButton from './Button'

export default {
  props: {
    value: String,
    readonly: Boolean,
    promise: Promise,
  },
  watch: {
    promise: {
      handler(val) {
        if (!val) return (this.loading = false)
        this.loading = true
        val.then(() => (this.loading = false)).catch(() => (this.loading = false))
      },
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  components: {
    DropdownComponent,
    ButtonComponent,
    StatusButton,
  },
}
</script>

<style lang="scss">
.task-status {
  .elder-dropdown__trigger {
    align-items: center;
  }
}
</style>
